const no = {
  "about_us": "Om oss",
  "activities": "aktiviteter",
  "adult": "Voksen",
  "adults": "Voksne",
  "age": "Alder",
  "all": "Alle",
  "app_name": "Gausta",
  "appInfo": "Last ned Gausta-appen – din guide til Gausta",
  "articles": "Artikler",
  "bottom_collection_about": 'Om Gausta',
  "bottom_collection_opening_hours": 'Åpningstider',
  "bottom_collection_cabins": 'Hytter til salgs',
  "bottom_collection_contact": 'Kontaktinfo & åpningstider',
  "bottom_collection_news": 'Nyheter',
  "bottom_collection_work": 'Jobbe på Gausta',
  "title_service": 'Kundservice',
  "breadcrumb_prefix": "Du er her:",
  "cabins_and_apartments": "Hytter og leiligheter",
  "call": "Anrop",
  "career_application_period": "Søknadsperiode",
  "career_application": "Applikasjon",
  "career_available_positions": "Ledige stillinger",
  "career_employer": "Arbeidsgiver",
  "career_jobtitle": "Jobbtittel",
  "career_jobtype": "Type jobb",
  "center_collection1_accomodation": 'Overnatting',
  "center_collection1_here": 'Reisen hit',
  "center_collection1_maps": 'Kart',
  "center_collection1_offers": 'Tilbud og kampanjer',
  "center_collection1_packages": 'Pakker',
  "center_collection1_service": 'Servicetjenester',
  "center_collection1_app": 'Gausta-appen',
  "center_collection1_transport": 'Transport',
  "center_collection1_title": 'PLANLEGGE TUREN',
  "center_collection1_webcams": 'Webkamera',
  "center_collection2_calendar": 'Aktivitetskalender',
  "center_collection2_food": 'Spise og drikke',
  "center_collection2_gaustabanen": 'Gaustabanen',
  "center_collection2_gaustaoppen": 'Gaustatoppen',
  "center_collection2_see": 'Se og gjøre',
  "center_collection2_health": 'Helse og velvære',
  "center_collection2_skisenter": 'Gausta skisenter',
  "center_collection2_title": 'OPPLEVE GAUSTA',
  "center_collection2_travel": 'Reiseguider',
  "center_collection3_courses": 'Skiopplevelser og kurs',
  "center_collection3_rental": 'Skiutleie',
  "center_collection3_school": 'Skiskole og privattimer',
  "center_collection3_ski": 'Heiskort',
  "center_collection3_season": 'Sesongkort',
  "center_collection3_title": 'KJØP/BOOK',
  "center_collection3_meeting": 'Møte og konferanse',
  "center_collection4_title": 'OM GAUSTA',
  "bottom_collection_renting_cabin": "Leie ut hytta?",
  "check_in": "Sjekk inn",
  "check_out": "Sjekk ut",
  "child": "Barn",
  "children": "Barn",
  "childrens_age": "Barnas alder",
  "closed": "Lukket",
  "coming_days_prognosis": "Prognose for kommende dager",
  "contact_information": "Kontaktinformasjon",
  "customer_service_collection_contact": 'Kontaktinfo og åpningstider',
  "customer_service_collection_faq": 'FAQ',
  "customer_service_collection_save": 'Trygt og sikkert',
  "customer_service_collection_terms": 'Bestillingsvilkår',
  "customer_service": "Kundeservice",
  "eat_and_drink": "Mat & Drikke",
  "email_placeholder": "Skriv inn epostadressen din",
  "error_404": "Side ikke funnet",
  "events_choose_dates": "Velg start/sluttdato",
  "events_upcoming_dates": "Kommende datoer",
  "events": "Arrangementer",
  "facebook_read_more": "Les mer på Facebook",
  "filter": "Filter",
  "fnugg_all_posts": "Se alle innlegg",
  "fnugg_cross_country": "Crosscountry",
  "fnugg_menu_cloud": "Skyet",
  "fnugg_menu_fog": "Tåke",
  "fnugg_menu_gausta_today": "Gausta i dag",
  "fnugg_menu_header": "Vær og driftsstatus",
  "fnugg_menu_puder_alert": "Pudderalarm!",
  "fnugg_menu_rain": "Regn",
  "fnugg_menu_snow": "Snø",
  "fnugg_menu_storm": "Storm",
  "fnugg_menu_sun": "Solfylt",
  "fnugg_menu_wind": "Vind",
  "fnugg_operation_status": "Driftsstatus",
  "fnugg_report_coming_days": "Prognose for kommende dager",
  "fnugg_report_last_day": "Siste dag",
  "fnugg_report_last_week": "Siste uke",
  "fnugg_report_terreng": "Terreng",
  "fnugg_report_weather_today": "Været i dag",
  "fnugg_snow_depth": "Snødybde",
  "fnugg_temp": "Temperatur",
  "footer_collection_about": "Om Gausta",
  "footer_collection_cabins_rent": "Leie ut hytta?",
  "footer_collection_cabins_sale": "Hytter til salgs",
  "footer_collection_career": "Jobbe på Gausta",
  "footer_collection_news": "Nyheter",
  "footer_email_subscribe": "Motta tilbud, nyheter, tips og mer i innboksen din",
  "footerText": "Gausta.com er offisiell bookingplattform for destinasjon Gausta. Her finner du det beste utvalget av overnatting i Gausta-området, heiskort til Gausta Skisenter og et bredt utvalg av aktiviteter og eksklusive pakker og tilbud.",
  "from_13_years": "Fra 13 år",
  "from": "Fra",
  "guests": "Gjester",
  "hotel": "Hotell",
  "last_day": "Siste dag",
  "last_updated": "Siste oppdatering",
  "last_week": "Sist uke",
  "lifts": "Heiser",
  "mail": "E-post",
  "map_temp": "Temp",
  "map_wind": "Vind",
  "maps_cross": "Cross country spor",
  "maps_summer": "Sommer kart",
  "maps_winter": "Løypekart",
  "menu": "Meny",
  "my_pages": "Mine sider",
  "on_this_page": "På denne siden",
  "only_lights": "Nattåpne bakker",
  "only_open": "Bare åpne",
  "open": "Åpen",
  "opened": "Åpnet",
  "other": "Annen",
  "overview": "Oversikt",
  "packages": "Pakker",
  "phone_number": "Telefonnummer",
  "policy": "Personvernpolicy",
  "read_more": "Les mer",
  "results": "resultater",
  "search_and_book": "Søk og bestill",
  "search_placeholder": "Søk i Gausta.com",
  "search": "Søk",
  "searchwidget_activities": "Våre aktiviteter",
  "searchwidget_adults_age": "Fra 13 år",
  "searchwidget_adults": "Voksne",
  "searchwidget_age": "Alder",
  "searchwidget_arrival": "Ankomst",
  "searchwidget_cabins": "Hytter og leiligheter",
  "searchwidget_child": "Barn",
  "searchwidget_children_age": "Alder 0-12",
  "searchwidget_children": "Barn",
  "searchwidget_departure": "Avreise",
  "searchwidget_guests": "Gjester",
  "searchwidget_hotel": "Hotell",
  "searchwidget_label_from": "Fra",
  "searchwidget_label_to": "Til",
  "searchwidget_picker_title": "Barnas alder",
  "searchwidget_skisenter_item": "Heiskort",
  "searchwidget_skisenter_item2": "Skiskole",
  "searchwidget_skisenter_item3": "Privattimer",
  "searchwidget_skisenter_item4": "Opplevelser og kurs",
  "searchwidget_skisenter_item5": "Skiutleie",
  "searchwidget_skisenter": "Gausta Skisenter",
  "searchwidgetmobile_title": "Bestill",
  "skicenter": "Skisenter",
  "slopes": "Bakker",
  "snow_depth": "Snødybde",
  "soMeText": "Hold deg oppdatert",
  "subscribe": "Abonner",
  "terrain": "Terreng",
  "to_12_years": "Aldre 0-12",
  "to": "Til",
  "top_collection_accomodation": 'Overnatting',
  "top_collection_food": 'Spise og drikke',
  "top_collection_gaustabanen": 'Gaustabanen',
  "top_collection_packages": 'Pakker',
  "top_collection_see": 'Se og gjøre',
  "top_collection_skisenter": 'Gausta skisenter',
  "topNotificationLink": null,
  "topNotificationMessage": "Testar ny notis norsk asd",
  "topRedBar_button": "Les mer",
  "topRedBar_message": "Vi forbedrer vår bookingplattform for en bedre gjesteopplevelse. Du kan fortsatt foreta bestillinger, men hvis du opplever problemer, vennligst kontakt oss på tlf.",
  "topRedBar_message2": "eller",
  "topRedBar_message3": "for assistanse",
  "topRedBar_phone": "35091422",
  "upcoming": "Kommende",
  "view_only": "VIS BARE",
  "visit": "Besøk",
  "weather_today": "Været i dag",
  "weather": "Vær",
  "webcams": "Webkameraer",
  "website": "Nettsted",
  "widget_book_at_gausta": "Bestill på Gausta",
  "wind": "Vind",
  "newpassword": "Opprett nytt passord",
  "resetPassword": "Ditt nye passord er nå lagret!",
  "buttonContinueText": "Fortsett",
  "newPasswordDescription": "Opprette nytt passord",
  "newPasswordDescription2": "For å opprette et nytt passord, skriv inn e-postadressen din:",
  "temporaryPasswordDescription": "Et nytt midlertidig passord har nå blitt sendt til deg på følgende e-postadresse:",
  "temporaryPasswordDescription2": "Dersom denne e-postadressen er registrert, så vil du nå motta et midlertidig passord i din innboks. Vennligst skriv inn dette i feltet under:",
  "temporaryPasswordLabel": "Midlertidig passord",
  "belowPassword": "Under kan du skrive inn et selvvalgt passord:",
  "newPasswordLabel": "Nytt passord",
  "repeatPasswordLabel": "Gjenta passord",
  "email": "E-post",
  "login": "Logg inn",
  "password": "Passord",
  "forgotPassword": "Glemt passord?",
  "accountNotFound": "Beklager, men det ser ikke ut til at denne e-postadressen er linket til noen brukerkonto.",
  "wrongPassword": "Beklager, men det ser ikke ut til at passordet er riktig",
  "unexpectedError": "Uventet feil",
  "link_accomodation": "/overnatting",
  "link_packages": "/pakker",
  "link_food_and_drink": "/spise-og-drikke",
  "link_see_and_do": "/se-og-gjore",
  "link_health_and_wellness": "/behandlinger",
  "link_gausta_skisenter": "/gausta-skisenter",
  "link_gaustabanen": "/gaustabanen",
  "link_offers": "/tilbud-og-kampanjer",
  "link_services": "/servicetjenester",
  "link_app": "/gausta-appen",
  "link_transport": "/buss",
  "link_get_here": "/reisen-hit",
  "link_webcams": "/webkamera",
  "link_maps": "/kart",
  "link_event_calendar": "/aktivitetskalender",
  "link_travel_guides": "/reiseguider",
  "link_gaustaoppen": "/gaustatoppen",
  "link_ski_pass": "/heiskort",
  "link_season_pass": "/sesongkort",
  "link_ski_school": "/skiskole",
  "link_ski_rental": "/skiutleie",
  "link_meeting": "/konferanse",
  "link_experiences_and_courses": "/skiopplevelser-og-kurs",
  "link_contact": "/kontakt-oss/",
  "link_opening_hours": "/apningstider",
  "link_about_gausta": "/om-gausta",
  "link_work_at_gausta": "/jobbe-pa-gausta",
  "link_news": "/nyheter",
  "link_cabins_for_sale": "/hytter-til-salgs",
  "link_cabins_rent": "/leie-ut-hytta",
  "link_contact_us": "/kontakt-oss",
  "link_faq": "/faq",
  "link_safe_and_sounds": "/trygt-og-sikkert",
  "link_terms_and_conditions": "/generelle-bestillingsvilkar",
  "link_cart": "/handlekurv",
  "link_home": "/",
  "link_sesongkort": "/gausta-skisenter",
  "link_heiskort": "/heiskort",
  "link_search": "/sok",
  "link_searchbutton_hotel": "https://book.gausta.com/no/stays/hotel/1967823?category=35937",
  "link_searchbutton_cabinsAndApartments":"https://book.gausta.com/no/stays?category=35936",
  "link_searchbutton_aktiviteter":"https://book.gausta.com/no/bestill/se-og-gjore?",
  "link_privacy_policy": "/personvernpolicy",
  "link_hotel_mobile": "https://book.gausta.com/no/stays/hotel/1967823?category=35937",
  "link_cabins_mobile": "https://book.gausta.com/no/stays?category=35936&gc-0-adults=1",
  "link_aktiviter_mobile": "https://book.gausta.com/no/bestill/se-og-gjore?filter=c=42324&sorting=st=a;so=a",
  "external_link_ski_school": "https://book.gausta.com/no/skiskole",
  "link_ski_private_lessons": "https://book.gausta.com/no/privattimer",
  "link_experiences": "https://book.gausta.com/no/skiopplevelser",
  "external_link_ski_rental": "https://book.gausta.com/no/skiutleie",
  "link_renting_cabin": "/leie-ut-hytta",
  "season_pass_label": 'Sesongkort',
  "lodging_label": 'Overnatting & Heiskort',
  "lodging": "losji",
  "footer_skisenter": "/gausta-skisenter/",
  "footer_skiskole": "/skiskole/",
  "footer_aktivitetssenter": "/se-og-gjore/",
  "footer_dagligvare": "/pose-og-sekk-dagligvare/",
  "footer_bakeriet": "/bakeriet/",
  "footer_gaustabanen": "/gaustabanen/",
  "footer_rjukan": "https://www.visitrjukan.com/",
  "footer_stova": "/gausta-food-court/",
  "footer_loftet": "/aktivitetskalender/afterski-loftet/",
  "continueButton": "Fortsett uten å logge inn"
}

export default no
